<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  created () {
    document.title = this.$t("Title")
  }
}
</script>

<style lang="stylus">
#app {
  width: 100%;
  height: 100vh;
  background: #ebebeb;
}
</style>
